// Only one item MUST have the "default: true" key

module.exports = {
  sv: {
    name: 'sv',
    default: true,
    path: `sv-se`,
    displayName: `SV`,
    locale: `sv-SE`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `sv-se`,
    ogLanguage: `sv_SE`,
    hrefLang: `sv-SE`,
    eventbriteLanguage: 'sv'
  },
  fi: {
    name: 'fi',
    path: `fi-fi`,
    displayName: `FI`,
    locale: `fi-FI`,
    dateFormat: `DD.MM.YYYY`,
    siteLanguage: `fi-fi`,
    ogLanguage: `fi_FI`,
    hrefLang: `fi-FI`,
    eventbriteLanguage: 'en_FI'
  },
  en: {
    name: 'en',
    path: `en-eu`,
    displayName: `EN`,
    locale: `en-EU`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `en-eu`,
    ogLanguage: `en_EU`,
    hrefLang: `en`,
    eventbriteLanguage: 'en_US'
  },
}
